import { GoToTrolley } from './GoToTrolley';

export default GoToTrolley;
